<ng-container [ngComponentOutlet]="serviceComponent()"></ng-container>
